"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
const details = [{
  step: "01",
  title: "ご予約",
  body: "電話・メールでご連絡いただくか、ご予約フォームよりご予約ください。お名前や連絡先、相談したいことなどについてお聞きし、初回のご予約日を決めていきます。電話がつながらない場合は留守番電話にて、お名前・連絡先・連絡可能な時間帯をお伝えください。こちらから折り返しお電話いたします。"
}, {
  step: "02",
  title: "初回面接",
  body: "待合室がないため、当日は予約時間ちょうどにお越しくださいますよう、お願いします。初回面接では「ご相談内容」「成育歴」「家族歴」「カウンセリングで期待すること」などについてお聞かせください。その後、ご相談者様についてのカウンセラーの見立てをお伝えし、当ルームでできることをご提案します。"
}, {
  step: "03",
  title: "アセスメント面接",
  body: "アセスメント面接では、初回面接で話しきれなかったことを話し合い、より詳細な見立てや今後のことについて検討していきます。回数は人によって異なりますが、およそ3〜5回程度です。改めて面接の最後にカウンセラーより、見立てや今後取り組んでいくことなどについてご報告します。"
}, {
  step: "04",
  title: "継続面接",
  body: "アセスメント面接で話し合ったことや、カウンセラーからご提案したことをもとに、お悩みに取り組んでいきます。継続面接がどのくらいの期間になるかは、ご相談者様によって大きく違ってきます。短いと3〜6ヶ月程度で終わる方もいますし、長いと数年受け続ける方もいます。なお、ご相談の内容によっては、初回面接の1回で終える方もいます。"
}, {
  step: "05",
  title: "フォローアップ面接",
  body: "継続面接を続けることでカウンセリングの目標を達成し、今後問題を抱えた場合にも自分で対処していけると感じられるようになると、カウンセリングの終了を意識するようになります。終了した後も不安を感じることがあれば、終了から3〜6ヶ月が経過したタイミングで、フォローアップ面接を設定できます。"
}];
export default function Flowdetail() {
  return <section id="flowdetail" className="bg-background pt-0 pb-16 md:pb-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-5xl">

        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground font-default leading-tight mb-4">各ステップについて</h2>
          <Separator className="w-12 h-0.5 bg-primary" />
        </div>

        <div className="border-t border-border divide-y divide-border">
          {details.map((item, i) => <div key={i} data-index={i} className="grid grid-cols-1 md:grid-cols-[200px_1fr] gap-4 md:gap-12 py-8 md:py-10 items-start">
              <div>
                <p className="text-sm font-bold text-primary font-default mb-1">STEP {item.step}</p>
                <h3 className="text-lg md:text-xl font-bold text-primary-heading font-default">{item.title}</h3>
              </div>
              <div className="space-y-4">
                <p className="text-foreground leading-relaxed font-default">{item.body}</p>
                {item.step === "01" && <div className="space-y-2">
                    <p className="font-default"><Link to="https://yotsuya-sc-room.com/reserve/" className="text-primary-heading underline underline-offset-4">ご予約・お問い合わせフォームはこちら</Link></p>
                    <p className="font-default"><Link to="https://yotsuya-sc-room.com/menu/" className="text-primary-heading underline underline-offset-4">カウンセリングメニュー・料金はこちら</Link></p>
                  </div>}
              </div>
            </div>)}
        </div>

      </div>
    </section>;
}